import AnalitycsCardContent from './AnalitycsCardContent.component';

export default AnalitycsCardContent;